// props and state are two key things
// 1. props
// props is how you get data into a component, they are sort of like HTML attributes
// data can come from state into components via props
// examples of props:
// <Inventory tagline="Wes is cool"  age={50} />  // numbers have to be in brackets  ...there are prop types, later...
// using a prop
// <span> {this.props.tagline} </span>
// the { } means "using javascipt for this" (JSX)
// the this is the component and the props is the props of the component
// so  {this.props.tagline} is "use the tagline props of the Inventory component


import React from "react";
import PropTypes from "prop-types";
// the Header is just a static component
import Header from "./Header";
import Order from "./Order";
// note the Inventory component has the AddFishForm component imported into it
import Inventory from "./Inventory";
// import sample fishes
import sampleFishes from "../sample-fishes";
// import Fish component
import Fish from "./Fish";
// import Firebase
import base from "../base";

class App extends React.Component {
    // STATE - put your state stuff at the top, not required but best
    // this is the state object for the entire App
    // you can pass state data down into child components but not up
    // you could create state this way
    // constructor() {
    //     super();  // what is super again?
    //     this.state = {
    //
    //     }
    // }
    // or with a property
    state = {
        fishes: {}, // empty object to start
        order: {}  // empty object to start
    };

    static propTypes = {
        match: PropTypes.object
    };

    // In next section, using React Lifecycle Methods
    // see: https://reactjs.org/docs/state-and-lifecycle.html

    // sync fish data to database
    // componentDidMount() = run after component loads
    componentDidMount() {
        // added this to reload local state first
        const localStorageRef = localStorage.getItem(this.props.match.params.storeId);
        if (localStorageRef) {
            // if there is local order storage, set the state order to it
            // since localStorageRef is a string, we need to turn it back into an object
            // with JSON.parse(), the opposite of JSON.stringify()
            this.setState({ order: JSON.parse(localStorageRef) });
        }
        // const { params } = this.props.match;
        // this.ref = base.syncState(`${params.storeId}/fishes`, {
        //     context: this,
        //     state: "fishes"
        // });
        // we store the ref to the database in this.ref
         this.ref = base.syncState(`${this.props.match.params.storeId}/fishes`, {
            context: this,
            state: "fishes"
        });
    }

    // start to store order data locally
    // componentWillUpdate() = run after component updates (but not when it loads)
    componentDidUpdate() {
        // console.log(this.state.order);
        // set local storage of order for this store
        // localStorage.setItem(this.props.match.params.storeId, this.state.order);
        // the above stores Object:Object into local storage because it is expectign a string so it tries to covert object to string
        // so we need to convert with JSON.stringify
        localStorage.setItem(
            this.props.match.params.storeId,
            JSON.stringify(this.state.order)
        );
    }

    // we stored above in this.ref so when we leave we do this
    // this is to "clean up" and stop listening when you leave the store
    componentWillUnmount()  {
        base.removeBinding(this.ref);
    }

    // So with the above code to connect to Firebase
    // when I refresh this page, it reloads the fish data, from Firebase
    // http://localhost:3000/store/magnificent-handsome-nuclei

    // METHODS - pur your methods next
    // the method for updating state, and the state itself have to live in the same component
    // here is the method for adding to state
    // method (function) addfish
    addFish = fish => {
        // 1. take a copy of the exisisting state
        // because you never want to directly modify state (which would be a mutation)
        const fishes = { ...this.state.fishes };  // the ... is called an object spread
        // 2. add our new fish to our fishes variable
        fishes[`fish${Date.now()}`] = fish;
        // 3. set the new fishes object to state using setState
        // this.setState({
        //     fishes: fishes  // this is adding the new fishes to the fishes in state
        // });
        // if the property and value have the same name, ES6 allows this shorthand
        this.setState({ fishes });
    };
    // how do we get the addFish method into our AddFishForm component?  with Props.
    // the addFish={this.addFish} in the <Inventory /> is a prop to add that method into Inventory component

    // see EditFishForm
    updateFish = (key, updatedFish) => {
        // 1. Take a copy of the current state
        const fishes = { ...this.state.fishes };
        // 2. Update that state
        fishes[key] = updatedFish;
        // 3. Set that to state
        this.setState({ fishes });
    };


    deleteFish = (key) => {
        // 1. take a copy of state
        const fishes = {...this.state.fishes};
        // 2. update the state
        fishes[key] = null;  // firebase requires deleting with null
        // 3. set the state
        this.setState({ fishes });
    };


    // a new function for loading sample fishes
    // to make this available to other components we add is as a prop to Inventory below
    // just like for addFish
    // then this function is called on a button in the Inventory component
    loadSampleFishes = () => {
        //alert("loading sample fishes");
        this.setState({fishes: sampleFishes});
    };

    addToOrder = (key) => {
        // 1. Take a copy of state
        const order = {...this.state.order};

        // 2. Either add fish to order, or update quantity
        // if order.fish1 exists, add 1, otherwise 1
        // order.fish1 = order.fish1 + 1 || 1;
        // use [key]
        order[key] = order[key] + 1 || 1;

        // 3. Call setState to update order in state
        // this.setState({order: order});
        // because key and value same name can do this:
        this.setState({order});
    };

    removeFromOrder = (key)  => {
        // 1. take copy of state
        const order = {...this.state.order};
        // 2. remove order
        delete order[key];
        // note we do not use this: order[key] = null;
        // because this is local only not to firebase
        // 3. update state
        this.setState({order});
    };

    // RENDER - pur your render stuff next
    render() {
        return (  // you need the ( after return  for multi line html
            <div className="catch-of-the-day">
                <div className="menu">
                    <Header tagline="Fresh Seafood Market"/>
                    {/* JSX does not have any logic, such as looping so you do it with Javascript  */}
                    <ul className="fishes">
                        {/* the fishes is an object, we need to make it an array, Object.keys gets the keys
                            the map function loops over the keys
                            the key={key} in <Fish /> Reacts wants to find that piece of data fast
                            the details prop is how we get the data from state into the Fish
                            the addToOrder is a method being passed down to Fish via props
                            the index={key} is needed to get the key to be available in the Fish
                            the key={key} is not enough (see Chapter 16 at 9:30)
                        */}
                        { Object.keys(this.state.fishes).map(key => (
                            <Fish key={key} index={key} details={this.state.fishes[key]} addToOrder={this.addToOrder}/>
                        )) }
                    </ul>
                </div>
                <Order
                    fishes={this.state.fishes}
                    order={this.state.order}
                    removeFromOrder={this.removeFromOrder}
                />
                <Inventory
                    addFish={this.addFish}
                    updateFish={this.updateFish}
                    deleteFish={this.deleteFish}
                    loadSampleFishes={(this.loadSampleFishes)}
                    fishes={this.state.fishes}
                    storeId={this.props.match.params.storeId}
                />
            </div>
        )
    }
}

export default App;

// NOTES
// To see the structure of a conponent, click on it in Chrome inspector, then print the $r in console
// Testing:
// You can run functions in console to test (see Chapter 16)
// 1. Select the component App, you will see $r
// 2. In console run this: $r.addToOrder('fish1')
// 3. Go back to App and you will see fish1 added to order

// This <Order fishes={this.state.fishes} order={this.state.order} />
// could be re-writeen using an "object spread":  <Order {...this.state} />
// which would pass the entire state down to <Order />
// he said that can be useful but bad practice
// best practice is to pass down only the data you need

// Notes on database
// React has "lifecycle merhods" sort of like jQuery document ready
// see: https://reactjs.org/docs/state-and-lifecycle.html
// we need to wait for component to load to sync data
//





// WEBPACK FOOTER //
// ./src/components/App.js